// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input_pbjck {
  flex: 1;
}`, "",{"version":3,"sources":["webpack://./src/geoPointEditors/LatLonEditor.css"],"names":[],"mappings":"AAAA;EACE,OAAO;AACT","sourcesContent":[".input {\n  flex: 1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"input": `input_pbjck`
};
export default ___CSS_LOADER_EXPORT___;
